<template>
    <b-modal v-model="modalShow" id="registrationModal" :hide-footer="true">
		<!-- <b-row class="mt-3">
			<b-col md="12">
				<pre>{{modalData}}</pre>
			</b-col>		
		</b-row> -->
		<div v-if="modalData=='BALLOT'" id="ballotForm">
			<div class="formTitle">
				<svg-image image="iconBallot"/>
				<h5>{{ $t("register.ballot") }}</h5>
			</div>
			<b-form @submit="doRegister">
				<div class="groupLabel"><label>{{ $t("register.form.detail.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.detail.race')" label-for="" :description="$t('register.form.detail.raced')">
						<b-form-select v-model="form.evpaEvncId">
							<b-form-select-option value="744">10K</b-form-select-option> 
							<b-form-select-option value="743">Half Marathon</b-form-select-option>
							<b-form-select-option value="742">Marathon</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="evpaWave-group" :label="$t('register.form.detail.time')" label-for="" :description="$t('register.form.detail.timed')">
					<vue-timepicker :hour-range="waveRange" class="timepicker" input-class="form-control" v-model="form.evpaWave"></vue-timepicker>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.detail.bib')" label-for="" :description="$t('register.form.detail.bibd')">
					<b-form-input
					id=""
					v-model="form.evpaBIBName"
					required
					placeholder=""
					maxlength="16"
					></b-form-input>
				</b-form-group>
				<!-- <img src="https://assets.heartwork.co.id/bormar/jersey.jpg" alt="Jersey">
				<b-form-group id="" :label="$t('register.form.detail.jersey')" label-for="" :description="$t('register.form.detail.jerseyd')">
						<b-form-select v-model="form.evpaJersey">
							<b-form-select-option value="XS">XS</b-form-select-option> 
							<b-form-select-option value="S">S</b-form-select-option>
							<b-form-select-option value="M">M</b-form-select-option>
							<b-form-select-option value="M">L</b-form-select-option>
							<b-form-select-option value="XL">XL</b-form-select-option>
							<b-form-select-option value="2XL">XXL</b-form-select-option>
							<b-form-select-option value="3XL">XXXL</b-form-select-option>
						</b-form-select>
				</b-form-group> -->
				<b-form-group id="community-group" :label="$t('register.form.detail.comm')" label-for="" :description="$t('register.form.detail.commd')">
					<v-select v-model="form.evpaCommunity" :options="communities" :create-option="option => option" :taggable="true" label="evpaCommunity"></v-select>
				</b-form-group>
				
				<div class="groupLabel"><label>{{ $t("register.form.emergency.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.emergency.name')" label-for="" :description="$t('register.form.emergency.named')">
					<b-form-input
					id=""
					v-model="form.evpaEmergencyContactName"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>
				<b-form-group id="phone-group"
					:label="$t('register.form.emergency.number')"
					label-for="phone"
					description=""
				>
					<b-form-group id="phone-group" label-for="phone">
						<VuePhoneNumberInput no-example class="form-group" color="#ea0c0c" :border-radius="0" required v-model="form_.evpaEmergencyContactNumber" default-country-code="ID" @update="phoneUpdated"/>
					</b-form-group>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.emergency.medic')" label-for="" :description="$t('register.form.emergency.medicd')">
					 <b-form-textarea
						id="textarea"
						v-model="form.evpaMedicalTreatment"
						placeholder=""
						rows="2"
						max-rows="6"
						>
					</b-form-textarea>
				</b-form-group>
				<b-form-checkbox
					id="acceptance"
					v-model="formChecked"
					name="acceptance"
					value="accepted"
					unchecked-value="not_accepted"
					>
					<div v-html="$t('register.form.acceptance')"></div>
				</b-form-checkbox>
				<div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg" :disabled="loading||formChecked!=='accepted'"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("register.form.btn") }}</b-button>
				</div>
			</b-form>
		</div>

		<div v-if="modalData=='FRQ'" id="frqForm">
			<div class="formTitle">
					<svg-image image="iconFRQ"/>
					<h5>{{ $t("register.frq") }}</h5>
			</div>
			<!-- <pre>
				{{modalData}}
				---
				{{form}}
			</pre> -->
			<b-form @submit="doRegister">
				<div class="groupLabel"><label>{{ $t("register.form.detail.label") }}</label></div>
				<b-form-group id="evpaEvncId" :label="$t('register.form.detail.race')" label-for="" :description="$t('register.form.detail.raced')">
						<b-form-select v-model="form.evpaEvncId">
							<b-form-select-option value="744">10K</b-form-select-option> 
							<b-form-select-option value="743">Half Marathon</b-form-select-option>
							<b-form-select-option value="742">Marathon</b-form-select-option>
						</b-form-select>
				</b-form-group>
				 <b-form-group id="" :label="$t('register.form.detail.bib')" label-for="" :description="$t('register.form.detail.bibd')">
					<b-form-input
					id=""
					v-model="form.evpaBIBName"
					required
					placeholder=""
					maxlength="16"
					></b-form-input>
				</b-form-group>
				<!-- <img src="https://assets.heartwork.co.id/bormar/jersey.jpg" alt="Jersey">
				<b-form-group id="" :label="$t('register.form.detail.jersey')" label-for="" :description="$t('register.form.detail.jerseyd')">
						<b-form-select v-model="form.evpaJersey">
							<b-form-select-option value="XS">XS</b-form-select-option> 
							<b-form-select-option value="S">S</b-form-select-option>
							<b-form-select-option value="M">M</b-form-select-option>
							<b-form-select-option value="M">L</b-form-select-option>
							<b-form-select-option value="XL">XL</b-form-select-option>
							<b-form-select-option value="2XL">XXL</b-form-select-option>
							<b-form-select-option value="3XL">XXXL</b-form-select-option>
						</b-form-select>
				</b-form-group> -->
				<b-form-group id="community-group" :label="$t('register.form.detail.comm')" label-for="" :description="$t('register.form.detail.commd')">
					<v-select v-model="form.evpaCommunity" :options="communities" :create-option="option => option" :taggable="true" label="evpaCommunity"></v-select>
				</b-form-group>

				<div class="groupLabel"><label>{{ $t("register.form.frq.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.frq.qrace')" label-for="" :description="$t('register.form.frq.qraced')">
					<b-form-input
					id="mmfrEventName"
					v-model="form.mmfrEventName"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>
				<b-form-group :label="$t('register.form.frq.qcat')" id="mmfrDescription" label-for="evpaFRrace" :description="$t('register.form.frq.qcatd')">
					<b-form-select v-model="form.mmfrDescription">
							<b-form-select-option value="10K">10K</b-form-select-option> 
							<b-form-select-option value="HalfMarathon">Half Marathon</b-form-select-option>
							<b-form-select-option value="Marathon">Marathon</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.frq.qtime')" label-for="evpaFRtime" :description="$t('register.form.frq.qtimed')">
					<vue-timepicker class="timepicker" input-class="form-control" v-model="form.mmfrResultTime" format="hh:mm:ss"></vue-timepicker>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.frq.qfile')" label-for="evpaFRcertificate" :description="$t('register.form.frq.qfiled')">
					<b-form-file
						v-model="certificateFile"
						:placeholder="$t('validate.id.placefile')"
						:drop-placeholder="$t('validate.id.dropfile')"
						@change="handleFileUpload"
						accept=".jpg, .png, .pdf"
					></b-form-file>
					<!-- <b-progress :value="progress" class="mb-3"></b-progress> -->
					<b-progress class="mt-2" :max="200" height="2.5rem">
						<b-progress-bar :value="progress">
							{{progressAction}}<strong>{{ progress/2 }}</strong>
						</b-progress-bar>
					</b-progress>
					<div><label class="fileLabel">{{ $t("validate.id.labelselect") }} {{ certificateFile ? certificateFile.name : '' }}</label></div>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.frq.qurl')" label-for="evpaFRrace" :description="$t('register.form.frq.qurld')">
					<b-form-input
					id=""
					type="url"
					v-model="form.mmfrResultLink"
					:placeholder="$t('register.form.frq.qurlp')"
					></b-form-input>
				</b-form-group>
				
				<!-- <b-form-group id="" label="Race Year" label-for="" description="Year of the race">
						<b-form-select>
							<b-form-select-option value="2019">2019</b-form-select-option> 
							<b-form-select-option value="2018">2018</b-form-select-option>
							<b-form-select-option value="2017">2017</b-form-select-option>
						</b-form-select>
				</b-form-group> -->
				
				<div class="groupLabel"><label>{{ $t("register.form.emergency.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.emergency.name')" label-for="" :description="$t('register.form.emergency.named')">
					<b-form-input
					id=""
					v-model="form.evpaEmergencyContactName"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>
				<b-form-group id="phone-group"
					:label="$t('register.form.emergency.number')"
					label-for="phone"
					description=""
				>
					<b-form-group id="phone-group" label-for="phone">
						<VuePhoneNumberInput no-example class="form-group" color="#ea0c0c" :border-radius="0" required v-model="form_.evpaEmergencyContactNumber" default-country-code="ID" @update="phoneUpdated"/>
					</b-form-group>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.emergency.medic')" label-for="" :description="$t('register.form.emergency.medicd')">
					 <b-form-textarea
						id="textarea"
						v-model="form.evpaMedicalTreatment"
						placeholder=""
						rows="2"
						max-rows="6"
						>
					</b-form-textarea>
				</b-form-group>
				<b-form-checkbox
					id="acceptance"
					v-model="formChecked"
					name="acceptance"
					value="accepted"
					unchecked-value="not_accepted"
					>
					<div v-html="$t('register.form.acceptance')"></div>
				</b-form-checkbox>
				<alert :status="status"/>
				<div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg" :disabled="loading||formChecked!=='accepted'"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("register.form.btn") }}</b-button>
				</div>

			</b-form>
		</div>

		<div v-if="modalData=='JATENG'" id="bankForm">
			<div class="formTitle">
					<svg-image image="iconBank"/>
					<h5>{{ $t("register.bankjateng") }}</h5>
			</div>
			<b-form @submit="doRegister">
				<div class="groupLabel"><label>{{ $t("register.form.voucher.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.voucher.code')" label-for="" :description="$t('register.form.voucher.bjcode')">
					<b-form-input
					id=""
					v-model="form.code"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>

				<div class="groupLabel"><label>{{ $t("register.form.detail.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.detail.race')" label-for="" :description="$t('register.form.detail.raced')">
						<b-form-select v-model="form.evpaEvncId">
							<b-form-select-option value="744">10K</b-form-select-option> 
							<b-form-select-option value="743">Half Marathon</b-form-select-option>
							<b-form-select-option value="742">Marathon</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="evpaWave-group" :label="$t('register.form.detail.time')" label-for="" :description="$t('register.form.detail.timed')">
					<vue-timepicker class="timepicker" input-class="form-control" v-model="form.evpaWave"></vue-timepicker>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.detail.bib')" label-for="" :description="$t('register.form.detail.bibd')">
					<b-form-input
					id=""
					v-model="form.evpaBIBName"
					required
					placeholder=""
					maxlength="16"
					></b-form-input>
				</b-form-group>
				<img src="https://assets.heartwork.co.id/bormar/jersey.jpg" alt="Jersey">
				<b-form-group id="" :label="$t('register.form.detail.jersey')" label-for="" :description="$t('register.form.detail.jerseyd')">
						<b-form-select v-model="form.evpaJersey">
							<b-form-select-option value="XS">XS</b-form-select-option> 
							<b-form-select-option value="S">S</b-form-select-option>
							<b-form-select-option value="M">M</b-form-select-option>
							<b-form-select-option value="M">L</b-form-select-option>
							<b-form-select-option value="XL">XL</b-form-select-option>
							<b-form-select-option value="2XL">XXL</b-form-select-option>
							<b-form-select-option value="3XL">XXXL</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="community-group" :label="$t('register.form.detail.comm')" label-for="" :description="$t('register.form.detail.commd')">
					<v-select v-model="form.evpaCommunity" :options="communities" :create-option="option => option" :taggable="true" label="evpaCommunity"></v-select>
				</b-form-group>
				
				<div class="groupLabel"><label>{{ $t("register.form.emergency.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.emergency.name')" label-for="" :description="$t('register.form.emergency.named')">
					<b-form-input
					id=""
					v-model="form.evpaEmergencyContactName"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>
				<b-form-group id="phone-group"
					:label="$t('register.form.emergency.number')"
					label-for="phone"
					description=""
				>
					<b-form-group id="phone-group" label-for="phone">
						<VuePhoneNumberInput no-example class="form-group" color="#ea0c0c" :border-radius="0" required v-model="form_.evpaEmergencyContactNumber" default-country-code="ID" @update="phoneUpdated"/>
					</b-form-group>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.emergency.medic')" label-for="" :description="$t('register.form.emergency.medicd')">
					 <b-form-textarea
						id="textarea"
						v-model="form.evpaMedicalTreatment"
						placeholder=""
						rows="2"
						max-rows="6"
						>
					</b-form-textarea>
				</b-form-group>
				<b-form-checkbox
					id="acceptance"
					v-model="formChecked"
					name="acceptance"
					value="accepted"
					unchecked-value="not_accepted"
					>
					<div v-html="$t('register.form.acceptance')"></div>
				</b-form-checkbox>
				<div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg" :disabled="loading"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("register.form.btn") }}</b-button>
				</div>
			</b-form>
		</div>

		<div v-if="modalData=='TRAVEL'" id="travelForm">
			<div class="formTitle">
					<svg-image image="iconTravel"/>
					<h5>{{ $t("register.travel") }}</h5>
			</div>
			<b-form @submit="doRegister">
				<div class="groupLabel"><label>{{ $t("register.form.voucher.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.voucher.code')" label-for="" :description="$t('register.form.voucher.trcode')">
					<b-form-input
					id=""
					v-model="form.code"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>

				<div class="groupLabel"><label>{{ $t("register.form.detail.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.detail.race')" label-for="" :description="$t('register.form.detail.raced')">
						<b-form-select v-model="form.evpaEvncId">
							<b-form-select-option value="744">10K</b-form-select-option> 
							<b-form-select-option value="743">Half Marathon</b-form-select-option>
							<b-form-select-option value="742">Marathon</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="evpaWave-group" :label="$t('register.form.detail.time')" label-for="" :description="$t('register.form.detail.timed')">
					<vue-timepicker class="timepicker" input-class="form-control" v-model="form.evpaWave"></vue-timepicker>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.detail.bib')" label-for="" :description="$t('register.form.detail.bibd')">
					<b-form-input
					id=""
					v-model="form.evpaBIBName"
					required
					placeholder=""
					maxlength="16"
					></b-form-input>
				</b-form-group>
				<img src="https://assets.heartwork.co.id/bormar/jersey.jpg" alt="Jersey">
				<b-form-group id="" :label="$t('register.form.detail.jersey')" label-for="" :description="$t('register.form.detail.jerseyd')">
						<b-form-select v-model="form.evpaJersey">
							<b-form-select-option value="XS">XS</b-form-select-option> 
							<b-form-select-option value="S">S</b-form-select-option>
							<b-form-select-option value="M">M</b-form-select-option>
							<b-form-select-option value="M">L</b-form-select-option>
							<b-form-select-option value="XL">XL</b-form-select-option>
							<b-form-select-option value="2XL">XXL</b-form-select-option>
							<b-form-select-option value="3XL">XXXL</b-form-select-option>
						</b-form-select>
				</b-form-group>
				<b-form-group id="community-group" :label="$t('register.form.detail.comm')" label-for="" :description="$t('register.form.detail.commd')">
					<v-select v-model="form.evpaCommunity" :options="communities" :create-option="option => option" :taggable="true" label="evpaCommunity"></v-select>
				</b-form-group>
				
				<div class="groupLabel"><label>{{ $t("register.form.emergency.label") }}</label></div>
				<b-form-group id="" :label="$t('register.form.emergency.name')" label-for="" :description="$t('register.form.emergency.named')">
					<b-form-input
					id=""
					v-model="form.evpaEmergencyContactName"
					required
					placeholder=""
					></b-form-input>
				</b-form-group>
				<b-form-group id="phone-group"
					:label="$t('register.form.emergency.number')"
					label-for="phone"
					description=""
				>
					<b-form-group id="phone-group" label-for="phone">
						<VuePhoneNumberInput no-example class="form-group" color="#ea0c0c" :border-radius="0" required v-model="form_.evpaEmergencyContactNumber" default-country-code="ID" @update="phoneUpdated"/>
					</b-form-group>
				</b-form-group>
				<b-form-group id="" :label="$t('register.form.emergency.medic')" label-for="" :description="$t('register.form.emergency.medicd')">
					 <b-form-textarea
						id="textarea"
						v-model="form.evpaMedicalTreatment"
						placeholder=""
						rows="2"
						max-rows="6"
						>
					</b-form-textarea>
				</b-form-group>
				<b-form-checkbox
					id="acceptance"
					v-model="formChecked"
					name="acceptance"
					value="accepted"
					unchecked-value="not_accepted"
					>
					<div v-html="$t('register.form.acceptance')"></div>
				</b-form-checkbox>
				<div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg" :disabled="loading"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("register.form.btn") }}</b-button>
				</div>
			</b-form>
		</div>

		<div v-if="modalData=='FRIENDSHIP'" id="friendshipForm">
			<div class="formTitle">
				<svg-image image="iconFriendship"/>
				<h5>{{ $t("friendship.modal.head") }}</h5>
			</div>
			<p align="center">{{ $t("friendship.modal.desc") }}</p>
			<p align="center"><b-button to="https://borobudurmarathon.com/friendship-run" pill variant="outline-secondary">{{ $t("friendship.modal.cta") }} <b-icon icon="arrow-right"></b-icon></b-button></p>
			<b-row class="friendshipInfo">
				<b-col>
					<b-icon icon="flag" style="width: 120px; height: 120px;"></b-icon>
					<h5>{{ $t("friendship.modal.icon1h") }}</h5>
					<p v-html="$t('friendship.modal.icon1d')"></p>
				</b-col>
				<b-col>
					<b-icon icon="map" style="width: 120px; height: 120px;"></b-icon>
					<h5>{{ $t("friendship.modal.icon2h") }}</h5>
					<p v-html="$t('friendship.modal.icon2d')"></p>
				</b-col>
				<b-col>
					<b-icon icon="credit-card" style="width: 120px; height: 120px;"></b-icon>
					<h5>{{ $t("friendship.modal.icon3h") }}</h5>
					<p v-html="$t('friendship.modal.icon3d')"></p>
				</b-col>
			</b-row>
			<div class="wonder">
				<b-icon icon="check-circle" style="width: 75px; height: 75px;"></b-icon>
				<p>{{ $t("friendship.modal.msg") }}</p>
			</div>
			<b-form @submit="doRegister">
				<div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("friendship.modal.btn") }}</b-button>
				</div>
			</b-form>
		</div>

		<!-- <b-card class="mt-3" header="Form Data Result">
			<pre class="m-0">{{ form }}</pre>
		</b-card>
		<b-card class="mt-3" header="Session Output">
			<pre>{{data}}</pre>
		</b-card> -->
    </b-modal>
</template>
<script>
	import VueTimepicker from '../../node_modules/vue2-timepicker/src/vue-timepicker.vue'
	import SvgImage from '../components/SvgImage.vue';
	import VuePhoneNumberInput from 'vue-phone-number-input';
	import Alert from '../components/Alert.vue'
	import * as utils from '../util/utils'

	export default {
		props: {
			modalData:String
		},
		data() {
			return {
				waveLimit : {
					742 : [[0,6]],
					743 : [[0,3]],
					744 : [[0,1]]
				},
				formChecked : false,
				modalShow : false,
				progress: 0,
				certificateFile: undefined,
				progressAction: undefined,
				form_ : {
					phone : undefined
				},
				birthplaceOptions : {
					types: ['(cities)'],
					// componentRestrictions: {country: "id"}
				},
				addressOptions : {
					types: [],
					// componentRestrictions: {country: "id"}
				},
				form: {
					"evpaWave" : '00:00',
					"mmfrResultTime" : '00:00',
					evpaJersey : '-'
					// "mbsdFile": 'MUSTVALIDATE'
				},
				formPhone: {
					mbspCountryCode: undefined,
					mbspNumber: undefined
				},
				formStatus: {
					"mbsdIDNumberType": {
						state : null
					},
					"mbsdIDNumber": {
						state : null
					},
					"mbsdBirthDate": {
						state : null
					},
					"mbsdBirthPlace": {
						state : null
					},
					"mbsdNationality": {
						state : null
					},
					"mbsdCountry": {
						state : null
					},
					"mbsdProvinces": {
						state : null
					},
					"mbsdCity": {
						state : null
					},
					"mbsdAddress": {
						state : null
					},
					"mbsdRawAddress": {
						state : null
					},
					"mbsdFile": {
						state : null
					}
				},
				signedin : true,
				data: null,
				status: null,
				loading:false,
				checkingPhone: false,
				communities : [
					"Astra Runners",
					"Bank Jateng Runners",
					"Bank Jatim Runners",
					"Banteng Runners",
					"Banyumas Runners",
					"BBJ Runners",
					"BFI Runners",
					"Bintaro Trojan Runners",
					"Bogor Runners",
					"CEO Runners",
					"Combi Run Academy",
					"Derby Runners",
					"Djarum Runners",
					"DJP Runners",
					"Fake Runners",
					"Freeletics",
					"Freeport Runners",
					"Generali Runners",
					"Hoofdbureau Runners",
					"IndoRunners",
					"JB Playon",
					"KG Pelarian",
					"Kediri Runners",
					"Klaten Runners",
					"Kulinerun",
					"Kudus Runners",
					"LDR Indonesia",
					"Longrunrangers",
					"Magelang Runners",
					"Mandiri Runners",
					"Miles to Share",
					"Nestle Runners",
					"Optimum Runners",
					"Patria Run Blitar",
					"Pertamina Runners",
					"Playon Jogja",
					"Run For Indonesia",
					"RGO Malang",
					"RIOT",
					"RUNMDN",
					"Running Rage",
					"Semarang Runners",
					"Senayan Runners",
					"Sleman Runners",
					"Spartan Runners",
					"Solo Runners",
					"Telkom Runners",
					"Ubur Ubur Lari",
					"We Run JKT",
					"Wee Run",
					"Wonosobo Runners",
				]
			}
		},
		computed : {
			isLoggedIn : function(){ 
				// console.log('is this one logged in? ', this.$store.getters.isLoggedIn);
				return this.$store.getters.isLoggedIn
			},
			waveRange: function(){
				// console.log(this.form.evpaEvncId)
				return this.waveLimit[this.form.evpaEvncId];
			}
		},
		components : {
			Alert,
			VuePhoneNumberInput,
			SvgImage,
			VueTimepicker
		},
		methods: {
			parseError(err){
				if (err.response&&err.response.data&&err.response.data.status&&err.response.data.status.error){
					console.log('E1: ', err.response.data.status.error)
					console.log('E2: ', err.response.data.status.error.errors)
					if (err.response.data.status.error.errors&&err.response.data.status.error.errors.length > 0){
						err.response.data.status.error.errors.forEach((errors)=>{
							console.log('E3: ', errors);
							if (Array.isArray(errors)){
								errors.forEach((error)=>{
									console.log('E4: ', error);	
									this.formStatus[error.field].state = false;
									this.formStatus[error.field].message = error.message;
								})
							}
						})
					}
				}
			},
			doRegister(evt){
				this.loading = true;
				evt.preventDefault();
				this.userProfile = this.$store.getters.getUserProfile;
				var obj = this.form;
				obj.id = 208;
				obj.evpaEvnhId = obj.id;
				obj.evpaName = this.userProfile.profileData.mbsdFullName;
				obj.evpaEmail = this.userProfile.profileData.mbsdEmail;
				obj.evpaPhone = this.userProfile.phoneData.mbspCountryCode + this.userProfile.phoneData.mbspNumber;
				obj.evpaGender = this.userProfile.profileData.mbsdGender;
				obj.evpaBirthPlace = this.userProfile.profileData.mbsdBirthPlace;
				obj.evpaBirthDate = this.$moment(this.userProfile.profileData.mbsdBirthDate, 'YYYY-MM-DD', true).format('DD-MM-YYYY');
				obj.evpaAddress = this.userProfile.profileData.mbsdAddress;
				obj.evpaCity = this.userProfile.profileData.mbsdCity;
				obj.evpaCountry = this.userProfile.profileData.mbsdCountry;
				obj.evpaNationality = this.userProfile.profileData.mbsdNationality;
				obj.evpaIDNumberType = this.userProfile.profileData.mbsdIDNumberType;
				obj.evpaIDNumber = this.userProfile.profileData.mbsdIDNumber;
				// obj.evpaCommunity = this.userProfile.profileData.mbsdAddress;
				obj.evpaBloodType = this.userProfile.profileData.mbsdBloodType;
				// obj.evpaBloodType = "ALIEN";
				// obj.evpaMedicalTreatment = 'Patah Tulang';
				this.$store.dispatch('REGISTEREVENT',{data:[obj], type:this.modalData})
					.then((registerOut) =>{
						this.loading = false;
						console.log('Regitered : ', registerOut);
						this.$parent.transactionData = registerOut.data;
						this.$parent.init();
						// this.$router.push('/');
						this.modalShow = false;
					})
					.catch(err => {
						this.loading = false;
						this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
					})


				console.log('data to construct : ', obj);
			},
			onFile(){

			},
			handleFileUpload(evt){
				console.log('abc', evt.target.files);
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				console.log('Process upload...', evt.srcElement.files[0]);
				// evt.target.files.forEach(function(file){
					formData.append('certificate',evt.srcElement.files[0]);
				// })
				// console.log(formData);
				this.$store.dispatch('UPLOADCERTIFICATE', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 200 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.progressAction = 'Uploaded';
						this.loading = false;
						var fileUploadOut = uploadOut.data;
						this.form.mmfrResultFile = fileUploadOut.processingId;
						console.log('Upload success : ', fileUploadOut);
						this.fileUploaded = true;
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})
			},
			phoneUpdated(value){
				this.form.evpaEmergencyContactNumber = value.formattedNumber;
				// this.formPhone.mbspNumber = value.phoneNumber;
				// console.log(value);
			},
		},
		mounted(){
			// console.log(this.$moment('2020-12-02', 'YYYY-MM-DD', true).format('DD-MM-YYYY'))
			// this.userProfile = this.$store.getters.getUserProfile;
			// console.log('parent : ',this.$parent);
		},
	}
</script>


// WEBPACK FOOTER //
// RegistrationModal.vue